import { useSearchParams } from 'react-router';

interface IPaymentLocation {
  orderId: string | null;
}

const usePaymentLocation = (): IPaymentLocation => {
  const [params] = useSearchParams();

  return {
    orderId: params.get('OrderID')
  };
};

export default usePaymentLocation;
